<template>
    <div class="login">
        <section class="h-100 w-100 d-flex justify-content-center align-items-center">
            <b-col cols="12" sm="10" md="8" lg="6" class="mx-auto">
                <div class="card">
                    <div class="text-danger font-weight-bold h3 mb-4">
                        <img src="../../assets/logo_small_size.png" alt="Yamzit logo">
                    </div>

                    <b-row>
                        <b-col sm="1" md="1" lg="1"/>
                        <b-col cols="12" sm="10" md="10" lg="10" >
                            <b-alert show variant="danger" v-if="hasError">
                            <span class="error-message">
                                {{errorMessage}}
                            </span>
                            </b-alert>
                        </b-col>
                        <b-col sm="1" md="1" lg="1"/>
                    </b-row>

                    <b-form>
                        <div class="form-group">
                            <label class="font-weight-bold form-label">Email address or phone number</label>
                            <b-form-input id="email" type="email" v-model="phone" class="form-control " placeholder="you@example.com" name="email" value="" required/>

                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold form-label">Enter your password</label>
                            <b-form-input id="password" type="password" v-model="password" class="form-control " placeholder="************"
                                   name="password" required/>
                        </div>
                        <div class="d-flex justify-content-end">
                            <a href="#" class="text-danger label">Forgot password</a>
                        </div>

                        <b-overlay :show="loading" rounded="sm">
                          <div class="form-group text-center top-padding">
                            <button type="button" @click="onSubmit()" class="button">
                              Login
                            </button>
                          </div>
                        </b-overlay>

                      <p class="label">Don't have a Yamzit Account?
                        <router-link to="/signup" style="font-weight: bold; color: #bd2130;">Sign Up</router-link>
                      </p>

                    </b-form>
                </div>
            </b-col>
        </section>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import router from "../../app/router/router";
    export default {
        name: "Login",
        data(){
            return {
                phone:null,
                password:null,
                hasError:false,
                errorMessage:null,
                loading:false
            }
        },
        mounted() {
          if(localStorage.getItem("token")!= null && localStorage.getItem("business_id") != null)  {
              router.push("/home/give-or-redeem")
          }
        },
        methods:{
            ...mapActions(["accountLogin"]),
            onSubmit() {
                event.preventDefault()
                this.hasError = false
                this.loading = true
                let data = {
                    email_or_phone: this.phone,
                    pin: this.password
                }
                this.accountLogin(data);
            },
        },

        computed: {
            ...mapGetters([
                "getLoginResponse",
                "getLoginErrorResponse",
            ]),
        },
        watch: {
            getLoginResponse(){
                this.loading = false
                router.push("/locations")
            },
            getLoginErrorResponse(data){
                this.loading = false
                this.hasError = true
                this.errorMessage = data.error[0]
            }
        }
    }
</script>

<style scoped>
    @import "../../commons/css/main.css";

    .login{
        padding: 5%;
    }

    .error-message{
        font-size: 14px;
        text-align: center;
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .form-label{
      font-size: 14px;
    }

    .label{
      font-size: 14px;
    }

    .top-padding{
      margin-top: 20px;
    }

    .card{
        border: solid 1px #dedede;
        width: 100%;
        padding: 30px;
    }

    .button{
      width: 100%;
      height: 60px;
      background: #c82333;
      color: white;
      border: solid 1px #c82333;
      border-radius: 8px;
    }

    .button:hover{
      background: #9c1825;
    }

    @media only screen and (max-width: 800px) {

      .card{
        margin-top: 100px;
      }

    }

    @media only screen and (max-width: 640px) {
      .button{
        height: 55px;
      }

    }

    @media only screen and (max-width: 570px){
        .error-message{
            font-size: 12px;
        }

        .form-label{
            font-size: 12px;
        }

        .label{
            font-size: 12px;
        }

        .button{
            font-size: 12px;
            height: 50px;
        }

        .h3{
            font-size: 18px;
        }

        .card{
          margin-top: 40px;
        }
    }

    @media only screen and (max-width: 380px){
        .error-message{
            font-size: 11px;
        }

        .form-label{
            font-size: 11px;
        }

        .label{
            font-size: 11px;
        }

        .button{
            font-size: 11px;
            height: 40px;
        }

        .h3{
            font-size: 16px;
        }

        .card{
            border: solid 1px #fff;
        }
    }

    @media only screen and (max-width: 320px){

      .button{
        height: 30px;
      }

    }

</style>